import {observer} from "mobx-react-lite"
import React, {useEffect} from "react"
import exportStatusController from "./ExportStatusController"
import {AsyncEntitySelection} from "../../components/AsyncEntitySelection"
import {Link, match, Route, useHistory} from "react-router-dom"
import "./exportHistory.sass"
import {appPages} from "../../App";
import {LongActionControls} from "../../components/task_buttons/LongActionControls";
import DictionaryApi from "../../api/DictionaryApi"
import {SkeletonBox} from "../../lib/wa-2.0"
import ReactPaginate from "react-paginate"


const ExportStatusComponent = observer(({match}: { match: match<{ launch_id: string}> }) => {
    const launch_id = match.params.launch_id

    useEffect(() => {
        exportStatusController.isNewLaunch(launch_id) && exportStatusController.loadLaunchData({launch_id})
    }, [launch_id])

    const history = useHistory();
    const handleRowClick = (id: number) => {
        history.push(appPages.exportHistory + '/launch/' + exportStatusController.launchId + '/product/'+id);
    }


    return <div>
        <h1>6. Статус экспорта</h1>
        <Link  className="button" to={appPages.exportHistory}>Назад</Link>
        {exportStatusController.productsLoaded ? <table>
            <thead style={{backgroundColor: "#F3F3F3"}}>
                <tr>
                    <th>Offer ID</th>
                    <th>Product ID</th>
                    <th>Название товара</th>
                    <th>Статус экспорта</th>
                    <th>Ошибок</th>
                </tr>
            </thead>
            <tbody>
            {exportStatusController.products.map((item, index) =>
                <tr key={index} onClick={()=>handleRowClick(index)} style={{cursor:'pointer'}}>
                    <td>{item.offer_id}</td>
                    <td>{item.product_id}</td>
                    <td>{item.name}</td>
                    <td>{item.status}</td>
                    <td>{item.errors_count}</td>
                </tr>
            )}
            </tbody>
        </table> : <SkeletonBox/>}
        {exportStatusController.lCountOfPages > 1 &&
        <div className={'paginate-compare'}>
            <ReactPaginate
                previousLabel={'Предыдущая'}
                nextLabel={'Следующая'}
                containerClassName={'paging'}
                pageCount={exportStatusController.lCountOfPages}
                pageRangeDisplayed={2}
                marginPagesDisplayed={2}
                initialPage={exportStatusController.lPage}
                onPageChange={({selected}) => {
                    exportStatusController.lPage = selected
                }
                }
            />
        </div>}
        {exportStatusController.task_ids.length > 0 &&
        <div className={'ozon_task_ids'}>
            {'Task IDs: '} {exportStatusController.task_ids.join(', ')}
        </div>
        }
    </div>
})

export default ExportStatusComponent